import * as React from 'react';
import { Route } from 'react-router';
import Layout from '../common/Layout';
import Albums from './Albums';

export default () => (
    <Layout>
        <Route exact path={["/admin/albums", "/admin/albums/:id", "/admin/albums/:id/*"]} component={Albums} />
        <Route path="/admin/settings" render={() => <div>settings</div>} />
    </Layout>
);